import './scss/tags.scss'

import type { Produto } from '@/components/vitrine/types/produto.props'
import type { Tags } from '@/components/vitrine/types/tags.props'

interface MidiaVitrineProps {
    readonly produto: Produto
    readonly hasTagEmbaixoProduto?: boolean
    readonly utilizaFavoritosVitrine?: boolean
}

export function TagsImagem({ produto, hasTagEmbaixoProduto = false, utilizaFavoritosVitrine = false}: MidiaVitrineProps) {
    const tags = produto?.tagsProduto ?? []
    const tagsFieltered = tags
        .filter(tag => hasTagEmbaixoProduto ? tag.posicao.value === 'embaixo-produto' : tag.posicao.value !== 'embaixo-produto')
        .filter(tag => (Number(tag.formaExibicao) !== 2 && tag.nomeExibicao) || (tag.midia?.midiaUrl))
        .filter(tag => tag.posicao.value !== 'inferior-titulo-desktop-inferior-midia-mobile')

    if(tagsFieltered.length === 0) return null

    return (
        hasTagEmbaixoProduto ?
            renderTagsEmbaixoProduto(tagsFieltered) :
            renderTagsSuperioresInferiores(tagsFieltered, utilizaFavoritosVitrine)
    )
}

function renderTagsSuperioresInferiores(tags: Tags[], utilizaFavoritosVitrine?: boolean) {
    type TagsPositionType = {
        [key: string]: string
    }

    const renderedPositions: { [key: string]: boolean } = {}

    const tagsPosition: TagsPositionType = {
        'superior-esquerdo': 'superior-esquerdo',
        'superior-direito': 'superior-direito',
        'inferior-esquerdo': 'inferior-esquerdo',
        'inferior-direito': 'inferior-direito',
    }

    const verificaParPosicoes = (posicoes: string[]): boolean => {
        return posicoes.every(posicao => tags.some(tag => tag.posicao.value === posicao && (tag.nomeExibicao || (tag.formaExibicao !== 2 && tag.midia?.midiaUrl))))
    }
    const hasTagMobile = verificaParPosicoes(['superior-esquerdo', 'superior-direito']) || verificaParPosicoes(['inferior-esquerdo', 'inferior-direito'])

    return (
        tags.map(tag => {
            const key = `${tag.id}_${tag.nomeExibicao}_${Math.random()}`
            const validateTagPosition = tags.filter(t => t.posicao.value === tag.posicao.value)

            if (renderedPositions[tag.posicao.value] || validateTagPosition.length === 0) {
                return null
            }
            
            renderedPositions[tag.posicao.value] = true

            return (
                <div
                    key={key}
                    className={`tag-area ${tagsPosition[tag.posicao.value]} ${hasTagMobile ? 'tag-area-mobile' : ''}${(utilizaFavoritosVitrine && (tag.posicao.value === 'superior-esquerdo' || tag.posicao.value === 'superior-direito')) ? ' has-tag-and-favorite' : ''}`}
                >
                    {validateTagPosition.map(tag => renderTag(tag))}
                </div>
            )
        })
    )
}

function renderTagsEmbaixoProduto(tags: Tags[]) {
    return (
        <div className="embaixo-produto">
            {tags.map(tag => renderTag(tag))}
        </div>
    )
}

function renderTag(tag: Tags) {
    const midiaWidth = tag.midia?.midiaOpcoes?.original.width && tag.midia?.midiaOpcoes?.original.width <= 200 ? tag.midia?.midiaOpcoes?.original.width : 40
    const midiaHeight = tag.midia?.midiaOpcoes?.original.height && tag.midia?.midiaOpcoes?.original.height <= 200 ? tag.midia?.midiaOpcoes?.original.height : 40
    const key = `${tag.id}_${tag.nomeExibicao}_${Math.random()}`

    return (
        <>
            {((Number(tag.formaExibicao) !== 2 && tag.nomeExibicao) || (tag.midia?.midiaUrl)) &&
                <div key={key} className={`tag-produto tag-${tag.id} ${tag.midia?.midiaUrl ? 'image' : ''}`}>
                    {Number(tag.formaExibicao) !== 2 && tag.nomeExibicao ? (
                        <div
                            className="tag-value"
                            style={{
                                backgroundColor: `#${tag.backgroundColor ?? "FFF"}`,
                                color: `#${tag.color ?? "000"}`,
                            }}
                        >
                            <div
                                className="text-tag"
                                dangerouslySetInnerHTML={{ __html: ` ${tag.nomeExibicao} ` }}
                            />
                        </div>
                    ) : 
                        (tag.midia?.midiaUrl &&
                            <img
                                title={tag.midia.midiaTitle || ""}
                                alt={tag.midia.midiaAlt || ""}
                                className="lazyload"
                                src={tag.midia.midiaUrl}
                                width={midiaWidth}
                                height={midiaHeight}
                                style={{ width: "100%" }}
                            />
                        )
                    }
                </div>
            }
        </>
    )
}


